<script>
    import { afterUpdate, onMount, onDestroy } from 'svelte'
    import { fly, slide } from 'svelte/transition'
    import { url, params, afterPageLoad } from '@sveltech/routify'
    import { indexShow } from '../store.js'
    import { getHash, handleHashChange } from '../js/hash-scroll.js'
    import Hamburger from './icons/Hamburger.svelte'
    import IndexMenu from './menu/IndexMenu.svelte'

    export let pages, slug, header

    $: activePage = pages.filter(page => getHash(page.title).includes(slug))
    $: pageUpdate(activePage)

    const subtitles = header.subtitles.map(s => s.value.subtitle)
    let subtitleVisible = false
    let subtitleIndex = 0
    let currentSubtitle = ''
    let firstLoad = true
    let intervalId = -1

    function rotateSubtitle () {
        subtitleIndex = (subtitleIndex + 1) % subtitles.length
        changeSubtitle(subtitles[subtitleIndex])
    }

    function changeSubtitle (subtitle) {
        subtitleVisible = false
        setTimeout(() => {
            currentSubtitle = subtitle
            subtitleVisible = true
        }, 200)
    }

    function pageUpdate (activePage) {
        if (activePage.length !== 0) {
            changeSubtitle(activePage[0].title)
            if (!firstLoad) {
                clearInterval(intervalId)
            }
        } else {
            changeSubtitle(subtitles[subtitleIndex])
            intervalId = setInterval(rotateSubtitle, 4000)
        }
        firstLoad = false
    }

    function toggleIndex () {
        indexShow.update(n => !n)
    }

    function headerClick (event) {
        if ($indexShow) {
            indexShow.update(n => !n)
        }
    }

    onMount(() => {
        window.addEventListener('hashchange', handleHashChange)
    })

    onDestroy(() => {
        window.removeEventListener('hashchange', handleHashChange)
    })
</script>

<div id="header">
    <div id="headerInner">
        <a on:click={headerClick} href={$url('/')} id="siteTitle">
            {header.title}
        </a>
        {#if subtitleVisible}
            <div class="sub" in:fly={{ y: -20, duration: 1000 }} out:fly={{ y: 10, duration: 1200 }}>
                {currentSubtitle}
            </div>
        {/if}
    </div>
    <div id="indexToggle">
        <div id="indexToggleInner" on:click={toggleIndex}>
            <Hamburger bind:indexShow={$indexShow} />
        </div>
    </div>
</div>
{#if $indexShow}
    <div id="index" in:slide out:slide>
        <IndexMenu {pages} bind:indexShow={$indexShow} />
    </div>
{/if}

<style lang="scss">
    @import "../styles/vars";

    #header {
        width: 100vw;
        background-color: white;
        overflow: auto;
        position: fixed;
        padding: 15px 0;
        z-index: 7;
    }

    #siteTitle {
        width: auto;
        text-align: center;
        display: block;
        font-family: Ysabeau;
        font-weight: bold;
        margin: 0 auto;
        padding: 0;
        font-size: 2.2rem;
        position: relative;
        color: black;
        text-decoration: none;
    }

    #headerInner {
        max-width: 900px;
        margin: 0 auto;
        position:relative;
    }

    .sub {
        position: relative;
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-style: italic;
        font-family: Ysabeau;
    }

    #indexToggle {
        position: absolute;
        right: 50px;
        height: 100%;
        top: 0;
        display:flex;
        align-items:center;

        #indexToggleInner{
            font-size: 3rem;
        }
    }

    #index {
        height: calc(100vh - 80px);
        position: fixed;
        top: 80px;
        width: 100%;
        background-color: white;
        z-index: 6;
        display: flex;
        align-items: center;
    }

    @include respond-to(phone) {
        #header {
            padding: 8px 0;
        }

        #index {
            top: 68px;
            bottom: 0;
            height: unset;
            padding-bottom: 5px;
        }

        #siteTitle {
            text-align: left;
            font-size: 1.4rem;
            padding-left: 1rem;
            display: inline-block;
        }

        .sub {
            text-align: left;
            font-size: 1rem;
            padding-left: 1rem;
            width: 75vw;
        }

        #indexToggle {
            right: 1.2rem;

            #indexToggleInner{
                font-size: 2rem;
                width: 30px;

                svg {
                    width: 100%;
                }
            }
        }
    }
</style>
